"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Input = require("./Input");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

var InputsContainer = _styledComponents["default"].div.withConfig({
  displayName: "CurrencyInput__InputsContainer",
  componentId: "sc-1vz64rv-0"
})(["position:relative;", ""], function (_ref) {
  var $hasPadding = _ref.$hasPadding;
  return $hasPadding && (0, _styledComponents.css)(["", "{padding-left:54px;}"], _Input.Input);
});

var CurrencyContainer = _styledComponents["default"].span.withConfig({
  displayName: "CurrencyInput__CurrencyContainer",
  componentId: "sc-1vz64rv-1"
})(["", ";position:absolute;top:2px;left:0;line-height:1;border-radius:3px;padding:2px;", " background-color:var(--bgColor);color:var(--textColor);"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.titleXS;
}, function (_ref3) {
  var theme = _ref3.theme;

  switch (theme.mode) {
    case 'light':
      return (0, _styledComponents.css)(["--textColor:var(--colors-moonRaker);--bgColor:var(--colors-governor);"]);

    case 'dark':
    default:
      return (0, _styledComponents.css)(["--textColor:var(--colors-bayoux);--bgColor:var(--colors-athensGray);"]);
  }
});

function CurrencyInput(_ref4) {
  var currency = _ref4.currency,
      children = _ref4.children;
  return __jsx(InputsContainer, {
    $hasPadding: !!currency
  }, children, currency && __jsx(CurrencyContainer, null, currency));
}

var _default = CurrencyInput;
exports["default"] = _default;